import * as types from '../constants/ActionTypes'

const monitoringsimult = (state = [], action) => {
    switch (action.type) {
      case types.ADD_MONITORING_SIMULT:
      return [
        ...state,
        {
            userout: action.userout,
            id: action.id,
            agent: action.agent,
            line: action.line,
            ramal: action.ramal
        }
      ]
      case types.MONITORING_DEL:
      return state.filter(monitoring =>
        monitoring.userout !== action.userout
      )
      case types.EDIT_MONITORING_S:
          return state.map(mon =>
            parseInt(mon.userout) === parseInt(action.userout) ?
            { 
              ...mon,
              line: action.line,
            } :
            mon
          )
      case types.EDIT_MONITORING_C:
        return state.map(mon =>
          parseInt(mon.userout) === parseInt(action.userout) ?
          { 
            ...mon,
            cdrid: action.cdrid,
          } :
          mon
        )
      default:
        return state
    }
  }
  
  export default monitoringsimult